import type { SkeletonProps as MUISkeletonProps } from '@mui/material';

import * as S from './styles';

export type SkeletonProps = {
  color?: string;
} & Partial<MUISkeletonProps>;

export const Skeleton = ({ ...restProps }: SkeletonProps) => {
  return <S.Skeleton data-testid="skeleton" {...restProps} />;
};
